import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { debtActions } from "../slices/debt";
import { getErrorMessage } from "../../utils/errorUtils";
import { DebtResponseDto } from "../../shared/dtos/debt/DebtResponseDto";
import { DebtSummaryDto } from "../../shared/dtos/debt/DebtSummaryDto";
import { PaymentRequestDto } from "../../shared/dtos/payment/PaymentRequestDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getDebts = (params?: any) => async (dispatch: AppDispatch) => {
  dispatch(debtActions.setLoadingFetchAll());
  try {
    const { data } = await axiosInstance.get<
      ApiResponseDto<PaginatedResponse<DebtSummaryDto>>
    >("/debts", {
      headers: { requiresAuth: true },
      params,
    });
    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(debtActions.setDebts(data.data.content));
      dispatch(debtActions.setPagination(data.data.pagination));
    }
  } catch (error) {
    dispatch(debtActions.setErrorFetchAll(getErrorMessage(error)));
  }
};

export const getDebtById = (id: string) => async (dispatch: AppDispatch) => {
  dispatch(debtActions.setLoadingFetchOne());
  try {
    const { data } = await axiosInstance.get<ApiResponseDto<DebtResponseDto>>(
      `/debts/${id}`,
      {
        headers: { requiresAuth: true },
      },
    );
    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(debtActions.setDebt(data.data));
    }
  } catch (error) {
    dispatch(debtActions.setErrorFetchOne(getErrorMessage(error)));
  }
};

export const recordDebtPayment =
  (id: string, payload: PaymentRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(debtActions.setLoadingPayment()); // Using factory Update loader for payments
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<DebtResponseDto>
      >(`/debts/payments/${id}`, payload, { headers: { requiresAuth: true } });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Payment recorded successfully!");
        dispatch(debtActions.setDebt(data.data));
        dispatch(
          debtActions.setServerStatus({
            operation: "pay",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(debtActions.setErrorPayment(message));
    }
  };

export const resetDebtServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(debtActions.setServerStatus(null));
};
